export { default as Spinner } from './src/Spinner'
